import { Modal, Typography } from '@crisellevaldez/speculo-ui';
import { Mail, Calendar } from 'lucide-react';
import { IconPill } from '../../common/IconPill';
import { useClientOwner } from '../../../hooks/useClientOwner';

interface ScheduleCallModalProps {
  isOpen: boolean;
  onClose: () => void;
  emailOnly?: boolean;
}

export function ScheduleCallModal({ isOpen, onClose, emailOnly = false }: ScheduleCallModalProps) {
  const owner = useClientOwner();
  const meetingUrl = `${owner.bookingUrl}?embed=true`;
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={emailOnly ? 'sm' : 'xl'}>
      <Modal.Header>
        <div className="text-center">
          <Typography variant="h3">Have Questions?</Typography>
          <p className="text-sm text-muted-foreground font-medium">
            {emailOnly
              ? 'Reach out to us for support'
              : 'Email us or schedule a call with your account strategist'}
          </p>
        </div>
      </Modal.Header>
      <Modal.Body>
        {/* Contact Options */}
        <div
          className={
            emailOnly
              ? 'flex items-center gap-3'
              : 'mb-4 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8'
          }
        >
          <div className="flex items-center gap-3">
            <IconPill icon={Mail} size="lg" />
            <div>
              <p className="text-sm font-medium text-foreground">Email Us</p>
              <a
                href={`mailto:${owner.email}`}
                className="text-sm text-amber-700 hover:text-amber-800 dark:text-amber-400 dark:hover:text-amber-300 hover:underline transition-colors"
              >
                {owner.email}
              </a>
            </div>
          </div>

          {!emailOnly && (
            <>
              <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                Or
              </span>

              <div className="flex items-center gap-3">
                <IconPill icon={Calendar} size="lg" />
                <div>
                  <p className="text-sm font-medium text-foreground">Schedule a Call</p>
                  <p className="text-sm text-muted-foreground">Pick a time below</p>
                </div>
              </div>
            </>
          )}
        </div>

        {/* HubSpot Meetings Embed - Only show when not emailOnly */}
        {!emailOnly && (
          <iframe
            src={meetingUrl}
            title={`Schedule a call with ${owner.displayName}`}
            width="100%"
            height="700"
            frameBorder="0"
            className="w-full"
          />
        )}
      </Modal.Body>
    </Modal>
  );
}
